import { DataBean } from "../DataBean";

export class FixedAssetItemStatesForDownloadItems extends DataBean {


    public async getFixedAssetItemStatesForDownloadItems(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemStatesForDownloadItems_Number", [id]);
    }

}